module.exports = __webpack_public_path__ + "img/chevron.d515e012.svg";